(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["morsey-product-confidence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('morsey-product-confidence')) {
    customElements.define('morsey-product-confidence', class extends HTMLElement {
      connectedCallback() {
        const productSection = this.closest('.product-information');
        if (productSection) {
          productSection.style.setProperty('--morsey-product-button-radius', `${this.dataset.buttonRadius || 2}px`);
          productSection.style.setProperty('--morsey-product-details-gap', `${this.dataset.detailsGap || 12}px`);
        }

        this.updateDeliveryDate();
        this.querySelectorAll('details').forEach((details) => this.prepareDetails(details));
      }

      updateDeliveryDate() {
        const output = this.querySelector('[data-morsey-delivery-date]');
        if (!(output instanceof HTMLTimeElement)) return;

        const deliveryDate = new Date();
        let businessDays = Number.parseInt(this.dataset.deliveryDays || '2', 10);
        while (businessDays > 0) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
          const day = deliveryDate.getDay();
          if (day !== 0 && day !== 6) businessDays -= 1;
        }

        const locale = this.dataset.locale || document.documentElement.lang || 'es';
        output.dateTime = deliveryDate.toISOString().slice(0, 10);
        output.textContent = new Intl.DateTimeFormat(locale, {
          day: 'numeric',
          month: 'long'
        }).format(deliveryDate);
      }

      prepareDetails(details) {
        if (!(details instanceof HTMLDetailsElement) || details.dataset.ready === 'true') return;
        const summary = details.querySelector('summary');
        const panel = details.querySelector('[data-morsey-details-panel]');
        if (!(summary instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
        details.dataset.ready = 'true';
        if (details.open) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        }
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (details.dataset.animating === 'true') return;
          this.animateDetails(details, panel, !details.open);
        });
      }

      setHalfPanelState(details, shouldOpen) {
        if (!details.classList.contains('morsey-product-confidence__details--half')) return false;
        const grid = details.closest('.morsey-product-confidence__details-grid');
        if (!(grid instanceof HTMLElement)) return false;

        const opensShipping = shouldOpen && details.classList.contains('morsey-product-confidence__details--shipping');
        const opensCare = shouldOpen && details.classList.contains('morsey-product-confidence__details--care');
        grid.classList.toggle('is-shipping-open', opensShipping);
        grid.classList.toggle('is-care-open', opensCare);
        return true;
      }

      wait(duration) {
        return new Promise((resolve) => window.setTimeout(resolve, duration));
      }

      nextFrame() {
        return new Promise((resolve) => {
          window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
        });
      }

      async animatePanel(panel, shouldOpen) {
        if (shouldOpen) {
          panel.style.height = '0px';
          panel.style.opacity = '0';
          await this.nextFrame();
          panel.style.height = `${panel.scrollHeight}px`;
          panel.style.opacity = '1';
          await this.wait(280);
          panel.style.height = 'auto';
          return;
        }

        panel.style.height = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';
        await this.nextFrame();
        panel.style.height = '0px';
        panel.style.opacity = '0';
        await this.wait(280);
      }

      async animateDetails(details, panel, shouldOpen) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        details.dataset.animating = 'true';

        try {
          if (reducedMotion) {
            details.open = shouldOpen;
            this.setHalfPanelState(details, shouldOpen);
            panel.style.height = shouldOpen ? 'auto' : '0px';
            panel.style.opacity = shouldOpen ? '1' : '0';
            return;
          }

          if (shouldOpen) {
            panel.style.height = '0px';
            panel.style.opacity = '0';
            details.open = true;
            const isHalfPanel = this.setHalfPanelState(details, true);
            if (isHalfPanel) await this.wait(420);
            await this.animatePanel(panel, true);
          } else {
            await this.animatePanel(panel, false);
            details.open = false;
            const isHalfPanel = this.setHalfPanelState(details, false);
            if (isHalfPanel) await this.wait(420);
          }
        } finally {
          delete details.dataset.animating;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
